const WARNING_MESSAGES: Record<string, string> = {
  storageLimitsWarning:
    'You have exceeded 95% of your storage. Please consider upgrading your storage soon!',
};

export default WARNING_MESSAGES;
